
<mat-card class="content-card">
  <div class="header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxLayout="column">
      <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>
    </div>
    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="table">
        <mat-form-field class="search-field">
          <input #searchField matInput (keydown.enter)="onSearch(searchButton.disabled)" placeholder="Search" [(ngModel)]="table.filters.str">
        </mat-form-field>
        <button #searchButton mat-icon-button (click)="onSearch()">
          <mat-icon>search</mat-icon>
        </button>
        <button mat-icon-button (click)="table.clearFilter()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <app-mat-table-generator #table
                           tableName="loadRefundTable"
                           [useEmbededFilter]="false"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [editEnabled]="false"
                           [deleteEnabled]="false"
                           [customQueryParams]="{f: 'refund-history'}"
                           [viewEnabled]="true"
                           [viewLink]="getViewLink"
                           [multiselectEnabled]="false"

  >
  </app-mat-table-generator>
</mat-card>
